import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import { Angle } from '@bibliocommons/deprecated-base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { searchEventComposer } from '@bibliocommons/analytics-event-composers';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { didNotFindOptionsShape } from '@bibliocommons/bc-prop-types';

import DidNotFindServiceItem from '../DidNotFindServiceItem';
import DidNotFindResourceItem from '../DidNotFindResourceItem';

import './DidNotFind.scss';

export default class DidNotFind extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleMoreResourcesClick() {
    const { didNotFindOptions, emptySearch } = this.props;
    const url = didNotFindOptions.get('additionalResourcesLink');
    sendAnalyticsEvents(
      searchEventComposer.composeDidNotFindMoreResourcesClickEvent({
        url,
        emptySearch
      })
    );
  }

  renderDidNotFindResources() {
    const { query, didNotFindOptions, emptySearch } = this.props;

    return didNotFindOptions
      .get('didNotFindResources')
      .map(resource => (
        <DidNotFindResourceItem
          className="did-not-find-resource"
          key={resource.get('resourceName')}
          query={query}
          resourceName={resource.get('resourceName')}
          resourceDescription={resource.get('resourceDescription')}
          resourceTags={resource.get('resourceTags')}
          resourceLink={resource.get('resourceLink')}
          emptySearch={emptySearch}
        />
      ));
  }

  renderDidNotFindServices() {
    const { didNotFindOptions, emptySearch } = this.props;

    return didNotFindOptions
      .get('didNotFindServices')
      .map(service => (
        <DidNotFindServiceItem
          className="did-not-find-service"
          key={service.get('id')}
          serviceId={service.get('id')}
          serviceName={service.get('localeKey')}
          serviceLink={service.get('link')}
          emptySearch={emptySearch}
        />
      ));
  }

  renderMoreResources() {
    const { didNotFindOptions } = this.props;

    return (
      didNotFindOptions.get('additionalResourcesLink') && (
        <a
          className="did-not-find-additional-resources-link"
          href={`${didNotFindOptions.get('additionalResourcesLink')}`}
          onClick={this.handleMoreResourcesClick}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span aria-hidden>
            <FormattedMessage id="view_more_resources" />
            <Angle.Right />
          </span>
          <ScreenReaderMessage>
            <FormattedMessage
              id="ada_opens_a_new_tab"
              values={{
                linkText: <FormattedMessage id="view_more_resources" />
              }}
            />
          </ScreenReaderMessage>
        </a>
      )
    );
  }

  render() {
    return (
      <div className="did-not-find">
        <div className="did-not-find-resources">
          <FormattedMessage id="other_resources" tagName="h3" />
          {this.renderDidNotFindResources()}
          <div className="did-not-find-more-resources">{this.renderMoreResources()}</div>
        </div>
        <div className="did-not-find-services">
          <FormattedMessage id="library_resources" tagName="h3" />
          {this.renderDidNotFindServices()}
        </div>
      </div>
    );
  }
}

DidNotFind.propTypes = {
  query: PropTypes.string,
  didNotFindOptions: didNotFindOptionsShape,
  emptySearch: PropTypes.bool
};
